/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetPapersFormats$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getPapersFormatsRequest = createAction<PayloadData<void>>('GET_PAPERS_FORMATS__GET_PAPERS_FORMATS__REQUEST');
export const getPapersFormatsSuccess = createAction<PayloadData<Array<DictionaryItem>>>('GET_PAPERS_FORMATS__GET_PAPERS_FORMATS__SUCCESS');
export const getPapersFormatsFailure = createAction<PayloadData<Error, void, true>>('GET_PAPERS_FORMATS__GET_PAPERS_FORMATS__FAILURE');

export const getPapersFormatsActions = [
    getPapersFormatsRequest,
    getPapersFormatsSuccess,
    getPapersFormatsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getPapersFormats = (config?: GetPapersFormats$Config) => {
    return {
        CALL_API: {
            types: getPapersFormatsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/papers-formats`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

